<template>
  <div class="supply-request width-responsiveness--centralized">
    <div class="supply-request__container">
      <subheader
        :title="title"
        :centralized="true"
        :path="'/gestao-de-insumos'"
        :back-button-visible="true"
      />

      <div class="supply-request__container input-forms">
        <div class="supply-request__form">
          <card-form :collapsed="true">
            <div
              slot="expanded"
              class="form-container"
            >
              <md-layout
                :md-gutter="24"
                md-flex="100"
              >
                <!-- name field -->
                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                >
                  <md-input-container
                    id="patientName"
                    :class="{'md-input-invalid': errors.has('name')}"
                  >
                    <label>Nome do solicitante</label>
                    <md-input
                      id="requesterName"
                      v-model="request.requester"
                      v-validate="'required'"
                      data-vv-validate-on="none"
                      name="name"
                      maxlength="60"
                      type="text"
                      title
                      placeholder="Nome do solicitante"
                    />
                    <span class="md-error">Obrigatório</span>
                  </md-input-container>
                </md-layout>

                <!-- email field -->
                <md-layout
                  md-flex="100"
                  md-flex-medium="100"
                >
                  <md-input-container
                    id="patientEmail"
                    :class="{'md-input-invalid': errors.has('labEmail')}"
                  >
                    <label>
                      Email do laboratório
                    </label>
                    <md-input
                      id="labEmail"
                      v-model="request.requesterEmail"
                      v-validate="'required|email'"
                      data-vv-validate-on="none"
                      name="labEmail"
                      maxlength="60"
                      type="email"
                      title
                      placeholder="Email do laboratório"
                    />
                    <span
                      v-if="errors.firstByRule('labEmail','required')"
                      class="md-error"
                    >Obrigatório</span>
                    <span
                      v-if="errors.firstByRule('labEmail','email')"
                      class="md-error"
                    >Email inválido</span>
                  </md-input-container>
                </md-layout>
              </md-layout>
            </div>
          </card-form>
        </div>
      </div>
      <div class="supply-request__container">
        <h3 class="supply-request__subtitle">
          Insumos
        </h3>
        <p class="supply-request__text">
          Procure e adicione insumos no seu pedido. Escolha a quantidade e motivo do pedido.
        </p>
        <supplies-select
          ref="suppliesSelect"
          :supplies="request.supplies"
          @update-list="updateList"
          @validData="updateValidChild"
        />
      </div>
      <div v-observe-visibility="visibilityChanged" />
      <div
        class="supply-request__container"
        :class="{
          'supply-request__floating-buttons': floatingButtons
        }"
      >
        <div class="supply-request__btn-row">
          <button
            class="supply-request__btn-bordered"
            @click="handleCancel"
          >
            Cancelar
          </button>
          <button
            class="supply-request__btn"
            :class="{
              'supply-request__btn--disabled': request.supplies.length === 0
            }"
            @click="validateBeforeSubmit"
          >
            <img
              src="/static/images/icon-check-thin.svg"
              alt="check"
            >
            {{ isEdit ? 'Salvar alterações' : 'Solicitar' }}
          </button>
        </div>
      </div>
    </div>
    <page-scroll-top />
    <supplies-confirmation-modal ref="confirmationModal" />
    <modal
      ref="loadingModal"
      template="loading"
      ref-name="loadingModal"
      title="Aguarde"
    >
      <p>Salvando solicitação...</p>
    </modal>
  </div>
</template>

<script>
import CardForm from '@/components/common/CardForm'
import SubHeader from '@/components/common/SubHeader'
import PageScrollTop from '@/components/common/PageScrollTop'
import RequestList from './SuppliesRequestList.vue'
import SuppliesSelect from './SuppliesSelect.vue'
import SuppliesConfirmationModal from './SuppliesConfirmationModal.vue'
import SupplyService from '@/api/supply'
import notify from '@/api/notification'
import { mapGetters } from 'vuex'

export default {
  name: 'SupplyRequest',
  components: {
    subheader: SubHeader,
    'page-scroll-top': PageScrollTop,
    'card-form': CardForm,
    SuppliesSelect,
    RequestList,
    SuppliesConfirmationModal
  },
  data: () => {
    return {
      request: {
        requester: '',
        requesterEmail: '',
        supplies: []
      },
      childValidData: false,
      floatingButtons: false,
      isEdit: false,
      supplies: []
    }
  },
  computed: {
    ...mapGetters(['profile']),
    title () {
      if (this.isEdit) {
        let id = this.$route.params.id
        return 'Alterar pedido ' + id
      }
      return 'Novo Pedido'
    },
    SuppliesSelectitems () {
      return this.requests
    }
  },
  mounted () {
    let id = this.$route.params.id
    if (id) {
      this.isEdit = true
      this.loadRequest(id)
    }
  },
  methods: {
    submitAnalyticsEvent (action) {
      let count = 0
      const supplies = this.request.supplies
      supplies.forEach(elm => {
        count = count + parseInt(elm.quantity)
      })
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Gestão de Insumos',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName,
        'total-insumos': count
      })
    },
    loadRequest (id) {
      SupplyService
        .getSupplyRequest(id)
        .then((response) => {
          let request = response.data
          request.supplies.map((item) => {
            item.reasonSelected = {
              value: item.reason,
              label: item.reason,
              hasJustification: item.justification.length > 0
            }
            return item
          })
          this.request = request
        })
    },
    clearFields () {
      this.request = {
        requester: '',
        requesterEmail: '',
        supplies: []
      }
    },
    updateValidChild (input) {
      this.childValidData = input
    },
    updateList (items) {
      this.request.supplies = items
    },
    validateBeforeSubmit () {
      if (this.request.supplies.length > 0) {
        const childComponent = this.$refs.suppliesSelect
        childComponent.validateBeforeSubmit()
        this.$validator
          .validateAll()
          .then((result) => {
            if (result) {
              if (this.childValidData) {
                this.handleUpsert()
              }
            }
          })
      }
    },
    visibilityChanged (isVisible) {
      this.floatingButtons = !isVisible
    },
    handleUpsert () {
      this.$refs.loadingModal.open()
      let items = this.request.supplies
      items = items.map((item) => {
        item.reason = item.reasonSelected.label
        delete item.hasJustification
        delete item.id
        if (!item.justification) {
          item.justification = ''
        }
        return item
      })
      this.request.supplies = items
      if (this.isEdit) {
        SupplyService
          .updateSupplyRequest(
            this.$route.params.id,
            this.request
          )
          .then(() => {
            notify({
              title: 'AVISO:',
              message: 'Seu pedido foi atualizado com sucesso.'
            })
            this.$refs.loadingModal.close()
            this.submitAnalyticsEvent('Atualizar solicitacao de insumos')
            this.$router.push({name: 'Gestão de Insumos'})
          })
          .catch(() => {
            this.$refs.loadingModal.close()
            notify({
              title: 'AVISO:',
              message: 'Não foi possível atualizar seu pedido.'
            })
          })
      } else {
        SupplyService
          .createSupplyRequest(this.request)
          .then((result) => {
            this.submitAnalyticsEvent('Criar solicitacao de insumos')
            this.clearFields()
            this.$refs.loadingModal.close()
            this.$refs.confirmationModal.openModal(result.data.number)
          })
          .catch(() => {
            this.$refs.loadingModal.close()
            notify({
              title: 'AVISO:',
              message: 'Não foi possível salvar seu pedido.'
            })
          })
      }
    },
    handleCancel () {
      this.$router.push('/gestao-de-insumos')
    }
  }
}
</script>

<style lang="scss">
.supply-request {
  font-family: 'Exo 2', sans-serif;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 58px);
  margin-top: 150px;

  &__container {
    width: 100%;
  }
  &__form {
    background-color: #fff;
    border-radius: 5px;
    padding: 10px 20px 5px 10px;
    margin-bottom: 30px;

    input {
      &::placeholder,
      &::-webkit-input-placeholder {
        color: #999999 !important;
      }
    }
  }
  .subheader {
    &__title {
      h2 {
        font-weight: bold !important;
      }
    }
  }
  &__subtitle {
    font-weight: bold;
    font-size: 20px;
    color: #6D6D6D;
    margin-bottom: 15px;
  }
  &__text {
    font-weight: normal;
    font-size: 16px;
    color: #303030;
    margin-bottom: 25px;
  }
  &__btn {
    background-color: #7F1A54;
    min-width: 142px;
    padding: 0 25px;
    height: 40px !important;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    font-family: 'Exo 2', sans-serif;
    font-weight: normal;
    border-radius: 4px;

    &--disabled {
      background-color: #CCCCCC !important;
      cursor: not-allowed;
    }

    &:hover {
      background-color: #5e133e;
    }
    img {
      margin-right: 8px;
    }
  }
  &__btn-bordered {
    background-color: transparent;
    border: 2px solid #7F1A54;
    width: 114px;
    color: #7f1a54;
    text-transform: uppercase;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;

    &:hover {
      color: #5e133e;
      border: 2px solid #5e133e
    }
  }
  &__btn-row {
    margin-top: 35px;
    margin-bottom: 35px;
    display: flex;
    justify-content: space-between;
  }
  &__floating-buttons {
    position: fixed;
    bottom: 0;
    width: calc(100% - 50px);
    left: 50px;
    padding: 0 12em;
    box-shadow: 0px -1px 4px rgba(0, 0, 0, 0.15);
    background-color: #F7F7F7;

    .supply-request__btn-row {
      margin: 12px 0;
    }
  }
  .card-form__container {
    padding: 0;
  }
}
</style>
